const recommenderRules = [
  {
    name: 'Price',
    field: 'price',
    type: 'numeric',
    mode: 'include',
    valueSource: 'manual',
    values: [0.01],
    valueMultipliers: [],
  },
  {
    name: 'Discount %',
    field: 'discountPercent',
    type: 'numeric',
    mode: 'off',
    values: [],
    valueMultipliers: [],
  },
  {
    name: 'Exact Category',
    field: 'categories',
    type: 'string',
    mode: 'off',
    values: [],
  },
  {
    name: 'Exact and Parent Categories',
    field: 'categorySplits',
    type: 'string',
    mode: 'off',
    values: [],
  },
  {
    name: 'Available Only',
    field: 'available',
    type: 'toggle',
    mode: 'include',
  },
  {
    name: 'Locale',
    field: 'locale',
    type: 'string',
    mode: 'off',
    values: [],
  },
  {
    name: 'Currency',
    field: 'currency',
    type: 'string',
    mode: 'off',
    values: [],
  },
  {
    name: 'Specific Product Ids',
    field: 'id',
    type: 'string',
    mode: 'off',
    values: [],
    preserveOrder: true,
  },
  {
    name: 'Specific SKUs',
    field: 'sku',
    type: 'string',
    mode: 'off',
    values: [],
    preserveOrder: true,
  },
  {
    name: 'Distance from user',
    field: 'inventory.location',
    type: 'geoDistance',
    mode: 'off',
    valueSource: 'manual',
    values: [],
    valueMultipliers: [],
  },
];

export default recommenderRules;
